import { Info } from "lucide-react";

const PilotageField = ({ label, hint = null, tooltip = null, htmlFor, error = null, children }) => {
  return (
    <label className="block space-y-2" htmlFor={htmlFor}>
      <div className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-1.5 text-sm font-medium text-slate-200">
          {label}
          {tooltip ? (
            <span
              title={tooltip}
              data-testid="pilotage-field-tooltip"
              className="cursor-help text-slate-400 hover:text-white inline-flex items-center"
            >
              <Info className="h-3.5 w-3.5" />
            </span>
          ) : null}
        </span>
        {hint ? (
          <span className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
            {hint}
          </span>
        ) : null}
      </div>
      {children}
      {error ? (
        <p className="text-xs text-red-400 font-medium mt-1" data-testid={`${htmlFor}-error`}>
          {error}
        </p>
      ) : null}
    </label>
  );
};

export default PilotageField;
